
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import 'lodash/isEqual';
import 'just-kebab-case';
import { P as PendoAnalytics } from './labels-mixin.js';
import { _ as _objectSpread } from './_rollupPluginBabelHelpers-mixin.js';
import 'lodash/kebabCase';
import 'feather-icons';
import './pendo-icon.js';
import Vue from 'vue';
import './collapse-transition-mixin.js';
import 'lodash/uniqueId';
import PendoCollapseItem from './pendo-collapse-item.js';
import VueScrollTo from 'vue-scrollto';
import 'lodash/isNumber';
import { g as getScrollParent } from './table-auto-height-mixin.js';

Vue.use(VueScrollTo);
var script = {
  name: 'PendoCollapse',
  components: {
    PendoCollapseItem
  },
  directives: {
    PendoAnalytics
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: [Array, String, Number],
      default: () => []
    },
    theme: {
      type: String,
      default: 'app'
    },
    accordion: {
      type: Boolean,
      default: false
    },
    panels: {
      type: [Array, Object],
      default: () => []
    },
    panelHeaderProps: {
      type: Object,
      default: () => ({})
    },
    panelScrollConfig: {
      type: [Boolean, Object],
      default: false
    },
    forceAlwaysOpen: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      expandedPanels: [...new Set([].concat(...[this.forceAlwaysOpen, this.value]))]
    };
  },

  provide() {
    return {
      $collapse: this
    };
  },

  computed: {
    model: {
      get() {
        return this.expandedPanels;
      },

      set(val) {
        this.expandedPanels = [...new Set([].concat(...[this.forceAlwaysOpen, val]))];
        this.$emit('change', this.expandedPanels);
      }

    },

    formattedPanels() {
      return this.panels.map(panel => _objectSpread({}, panel, {
        prefixIcon: _objectSpread({}, this.panelHeaderProps.prefixIcon, panel.prefixIcon),
        suffixIcon: _objectSpread({}, panel.suffixIcon !== false && {
          type: 'chevron-down',
          size: '14px',
          stroke: '#BABCC5'
        }, this.panelHeaderProps.suffixIcon, panel.suffixIcon)
      }));
    }

  },
  watch: {
    value(value) {
      this.expandedPanels = [...new Set([].concat(...[this.forceAlwaysOpen, value]))];
    }

  },
  methods: {
    scrollPanelIntoView(name) {
      if (!this.panelScrollConfig) {
        return;
      }

      const element = `#${name}`;
      const container = this.panelScrollConfig.container || getScrollParent(document.querySelector(element));
      this.$scrollTo(element, 300, {
        container,
        easing: 'ease-in-out',
        offset: this.panelScrollConfig.offset || 0
      });
    },

    handlePanelClick(name) {
      let expandedPanels = this.model.slice(0);
      const index = expandedPanels.indexOf(name);

      if (this.accordion) {
        if (index > -1) {
          expandedPanels = [];
        } else {
          this.scrollPanelIntoView(name);
          expandedPanels = [].concat(name);
        }

        this.model = expandedPanels;
        return;
      }

      if (index > -1) {
        expandedPanels.splice(index, 1);
      } else {
        this.scrollPanelIntoView(name);
        expandedPanels.push(name);
      }

      this.model = expandedPanels;
    }

  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "pendo-collapse",
    class: [_vm.theme, {
      'has-multiple-panels': _vm.formattedPanels.length > 1
    }],
    attrs: {
      "role": "tablist",
      "aria-multiselectable": "true"
    }
  }, [!_vm.panels.length ? _vm._t("default") : _vm._e(), _vm._v(" "), _vm._t("panels", _vm._l(_vm.formattedPanels, function (panel) {
    return _c('pendo-collapse-item', _vm._b({
      directives: [{
        name: "pendo-analytics",
        rawName: "v-pendo-analytics",
        value: {
          type: 'components:collapse',
          value: panel.name
        },
        expression: "{ type: 'components:collapse', value: panel.name }"
      }],
      key: panel.name,
      attrs: {
        "id": panel.name
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function (ref) {
          var content = ref.content;
          return [_vm._t(panel.name, [panel.component ? _c(panel.component, _vm._b({
            tag: "component"
          }, 'component', panel.componentProps, false)) : _vm._e()], {
            "pane": content
          })];
        }
      }], null, true)
    }, 'pendo-collapse-item', panel, false), [_c('template', {
      slot: "title"
    }, [_vm._t(panel.titleSlotName)], 2)], 2);
  }))], 2);
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-collapse.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var pendoCollapse = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

export default pendoCollapse;
